// BM-H589, 23 September 2026. One rule for every "notify a colleague" picker.
//
// The credit control notepad picker (BM-H549) cut the list at 8 people and the
// attendance note picker cut it at 20. With 14 active staff the credit control
// list stopped at Sharon, so Emily (9th) and Liezel (11th) never appeared
// unless you already knew to type their name. Nobody should have to know that.
//
// Rule: every active member of staff not already picked, in roster order,
// matched on name, email, initials or alias. No cap. The list box scrolls.
import { STAFF } from "../config/staffConfig";

export function staffNotifyCandidates(query, alreadyPicked = [], roster = STAFF) {
  const q = String(query || "").trim().toLowerCase();
  const picked = new Set((alreadyPicked || []).map((e) => String(e || "").toLowerCase()));
  return roster
    .filter((s) => s && s.is_active && s.email && !picked.has(String(s.email).toLowerCase()))
    .filter((s) => {
      if (!q) return true;
      const haystack = [s.full_name, s.email, s.initials, ...(s.aliases || [])]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return haystack.includes(q);
    });
}
